import { Icon, Text } from '@cencosud-cencommerce/paris-uikit';

import type { ShowMoreProps } from '.';

const ShowMore = ({ showMore, setShowMore }: ShowMoreProps) => {
  const buttonText = showMore ? 'Mostrar menos' : 'Mostrar más';
  const icon = showMore ? 'arrow-up' : 'arrow-down';

  return (
    <button
      className="co-w-fit co-self-center co-flex co-gap-8px co-items-center co-px-32px co-py-8px"
      onClick={() => setShowMore(!showMore)}
    >
      <Text
        variant="body2"
        weight={600}
        color="primary-500"
        className="co-underline"
      >
        {buttonText}
      </Text>
      <Icon fill="primary-500" name={icon} />
    </button>
  );
};

export default ShowMore;
